import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Réinventer le voyage",
      subtitle: "Une vision éthique, locale et humaine du tourisme de demain.",
    },
    mission: {
      badge: "Notre Mission",
      title: "Le tourisme équitable",
      description:
        "Nous croyons que le voyage doit être accessible à tous, sans intermédiaires coûteux. DONKEY TRAVEL permet aux propriétaires de voyager librement grâce à la valeur de leur propre bien.",
    },
    philosophy: {
      badge: "Notre Philosophie",
      title: "Fabrique en France et humain",
      description:
        "Ancrés dans la Vallée de la Somme, nous défendons un modèle artisanal face aux géants de la Tech. Pas d'algorithmes obscurs, juste du bon sens et de la convivialité.",
      values: {
        fair: {
          title: "Équitable",
          desc: "0% de commission sur les échanges. Juste un abonnement transparent.",
        },
        local: {
          title: "Ancrage Local",
          desc: "Fier de nos racines françaises, nous promouvons un tourisme respectueux des territoires.",
        },
        community: {
          title: "Communautaire",
          desc: "Un club privé de propriétaires de confiance qui partagent les mêmes valeurs.",
        },
      },
    },
    team: {
      badge: "L'Équipe",
      title: "Des passionnés à votre service",
      subtitle:
        "Derrière la plateforme, des humains qui aiment voyager et partager.",
      members: {
        ceo: {
          name: "Plük",
          role: "Créateur de DONKEY TRAVEL • Développeur • Superhost Airbnb depuis 4 ans",
          bio: "Pendant des années, j’ai accueilli des voyageurs dans mes gîtes, chez qui j’aurais moi-même pu aller si DONKEY TRAVEL avait existé. C’est pour ça que j’ai créé DONKEY TRAVEL : permettre aux hôtes de s’accueillir entre eux et de voyager autrement.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Architecte de la plateforme, garant de la sécurité.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Responsable Communication",
          bio: "La voix de DONKEY TRAVEL auprès de notre communauté.",
        },
      },
    },
    investors: {
      badge: "Investisseurs",
      title: "Rejoignez l'aventure",
      description:
        "DONKEY TRAVEL est en pleine croissance. Nous cherchons des partenaires qui partagent notre vision d'un tourisme durable et équitable.",
      cta: "Contactez-nous pour investir",
    },
  },
  trokOrigin: {
    badge: "Comprendre le concept",
    title: "Comment ça fonctionne exactement ?",
    subtitle:
      "Un échange direct entre deux personnes, sans intermédiaire ni système de points compliqué",
    etymology: {
      title: "L'origine du mot",
      historicalTitle: "Une pratique millénaire",
      text1:
        'Le mot "Troc" apparaît en français au XIVe siècle, dérivé du verbe "troquer". Il trouve ses racines dans l\'espagnol "trucque" et le wallon "trouk", évoquant l\'idée d\'échange direct.',
      text2:
        'Attesté dès 1364 sous la forme "truke" dans des documents anglo-normands, puis officialisé en 1464 dans les lettres patentes de Louis XI : "pour la vente, troc ou eschange d\'icelles denrées".',
      text3:
        "Chez DONKEY TRAVEL, nous avons gardé cette philosophie ancestrale : vous échangez directement votre logement avec un autre propriétaire. Pas de monnaie virtuelle, pas de points à accumuler. Juste un accord entre deux humains.",
      from: "Étymologie",
      meaning: "Échanger directement, de personne à personne",
      century14: "XIVe siècle",
      firstAttestation: "Première attestation en français",
      century15: "XVe siècle",
      officialUse: "Usage officiel par Louis XI",
      today: "Aujourd'hui",
      modernPractice: "Pratique moderne et collaborative",
    },
    direct: {
      title: "Échange direct uniquement",
      description:
        "Contrairement aux systèmes de points ou de crédits, DONKEY TRAVEL fonctionne sur le principe du troc pur. Vous négociez directement avec un autre propriétaire : vos nuits contre les siennes. C'est l'essence même du troc tel qu'il existe depuis le XIVe siècle.",
      result: "Échange direct validé !",
    },
    noTriangulation: {
      title: "Pas de triangulation",
      description:
        "Pas de système complexe où A donne à B qui donne à C. Ici, c'est simple : vous trouvez quelqu'un, vous négociez ensemble (dates simultanées ou décalées), vous échangez. Point final.",
      noPoints: "Pas de points à compter",
    },
    meetHost: {
      title: "Rencontrez un autre hôte Airbnb",
      description:
        "DONKEY TRAVEL, ce n'est pas juste découvrir un logement ou voyager. C'est avant tout rencontrer un autre passionné de l'accueil, quelqu'un qui partage vos valeurs d'hospitalité. Le troc a toujours été une pratique sociale avant d'être économique.",
      share: "Partagez vos expériences d'hôte",
      tips: "Échangez vos meilleures astuces",
      friendship: "Créez des amitiés durables",
      badge: "Communauté d'hôtes",
      badgeSub: "Des rencontres authentiques",
      step2Title: "2. Contrat amiable sur DONKEY TRAVEL",
      step2Desc:
        "Ils signent le contrat d'échange directement sur la plateforme et reçoivent le PDF par email. Tout est sécurisé et officiel.",
      contractSigned: "Contrat signé et sécurisé",
      step3Title: "3. Marie arrive à Paris (2 semaines plus tard)",
      step3Desc:
        "Jean accueille Marie chaleureusement. Il est impressionné : l'appartement est impeccable, Marie respecte tout. Quelle différence avec certains voyageurs Airbnb ! Ils discutent de leurs expériences d'hôtes autour d'un café.",
      step4Title: "4. Jean découvre Reims (6 mois plus tard)",
      step4Desc:
        "Jean arrive au gîte de Marie à Reims. Le cadre est magnifique ! Marie l'invite à dîner, ils mangent ensemble et refont le monde en parlant de voyages, d'Airbnb et de leurs meilleures anecdotes d'hôtes.",
      step5Title: "5. Une amitié durable",
      step5Desc:
        "Marie et Jean restent en contact. Ils décident de s'échanger régulièrement leurs logements. Plus qu'un simple échange, c'est une vraie amitié qui est née grâce à TRAVELTROK.",
      spiritTitle: "Voilà l'esprit DONKEY TRAVEL !",
      spiritDesc:
        "Des échanges authentiques entre propriétaires passionnés, dans le respect et la convivialité. Pas de points, pas de triangulation, juste du vrai troc à l'ancienne.",
    },
    negotiation: {
      badge: "Négociation ludique",
      title: "Négociez comme un jeu !",
      description:
        "10 nuits contre 5 ? Pourquoi pas ! Faites une offre, recevez une contre-offre, trouvez un accord. Le tout dans un esprit bon enfant. Comme au temps des premiers échanges, la négociation fait partie du plaisir.",
      marieProperty: "Gîte à Reims",
      jeanProperty: "Appartement à Paris",
      marieLocation: "Dans son gîte à Reims",
      jeanLocation: "Dans son appartement à Paris",
      marieAccepts: "Marie accepte l'offre",
      offers: "Offre",
      proposes: "Propose",
      nights: "nuits",
      status: {
        initial: "Marie fait une offre...",
        counter: "Jean fait une contre-offre !",
        negotiate: "Marie négocie...",
        deal: "Deal conclu ! 🎉",
      },
      chat: {
        msg1: "Je te propose {{marieNights}} nuits dans mon gîte à Reims contre {{jeanNights}} nuits à Paris !",
        msg2: "Jean trouve le logement de Marie très bien...",
        msg3: "Ton gîte est magnifique ! Je suis sympa, je te propose {{jeanNights}} nuits à Paris 😊",
        msg4: "Marché conclu ! 🤝",
        msg5: "Marie regarde les disponibilités de Jean...",
      },
      nextStep: "Étape suivante",
      restart: "Recommencer",
      points: {
        flexible: "Négociation flexible",
        friendly: "Ambiance conviviale",
        fair: "Accord équitable",
      },
    },
    flexibility: {
      title: "Flexibilité totale",
      description:
        "Contrairement aux échanges traditionnels, vous n'avez pas besoin de trouver quelqu'un qui veut votre logement exactement quand vous voulez le sien. Accumulez des Nuits et utilisez-les quand bon vous semble !",
    },
    example: {
      person1: "Marie",
      location1: "Paris, France",
      person2: "Jean",
      location2: "Lyon, France",
      result: "Échange réussi !",
    },
  },
  exchange: {
    title: "Comment ça marche ?",
    subtitle:
      "Un système simple et sécurisé pour échanger vos logements en toute confiance",
    features: {
      secure: {
        title: "Échanges sécurisés",
        description:
          "Tous les membres sont vérifiés et les avis garantissent la transparence de chaque échange.",
      },
      sync: {
        title: "Synchronisation calendrier",
        description:
          "Synchronisez automatiquement vos disponibilités avec votre calendrier Airbnb existant.",
      },
      global: {
        title: "Réseau européen",
        description:
          "Accédez aux membres hôtes dans les pays européens disponibles sur TRAVELTROK.",
      },
      chat: {
        title: "Messagerie intégrée",
        description:
          "Communiquez directement avec les autres propriétaires pour organiser vos échanges.",
      },
      rating: {
        title: "Système de notation",
        description:
          "Consultez les avis et notations pour choisir vos partenaires d'échange en toute confiance.",
      },
      savings: {
        title: "Économies garanties",
        description:
          "Voyagez gratuitement en utilisant vos Nuits au lieu de payer des hébergements coûteux.",
      },
    },
    steps: {
      title: "En 3 étapes simples",
      step1: {
        title: "Créez votre profil",
        description:
          "Inscrivez-vous et ajoutez les informations sur votre logement Airbnb en quelques minutes.",
      },
      step2: {
        title: "Trouvez votre destination",
        description:
          "Parcourez les logements disponibles et trouvez la destination de vos rêves.",
      },
      step3: {
        title: "Échangez et voyagez",
        description:
          "Proposez un échange, confirmez les dates et profitez de votre séjour gratuitement !",
      },
    },
  },
  worldMap: {
    title: "Top 20 des pays les plus actifs",
    subtitle:
      "Découvrez les pays où les échanges de logements sont les plus populaires aujourd'hui",
    description:
      "Notre communauté grandit chaque jour avec de nouveaux propriétaires dans le monde entier. Découvrez où vous pourriez voyager gratuitement.",
    badge: "Classement en temps réel",
    properties: "logements",
    cta: "Voir toutes les destinations",
    exchangesToday: "Échanges aujourd'hui",
    activeCountries: "Pays actifs",
    vsYesterday: "vs. hier",
    fullRanking: "Classement complet",
    countries: {
      Guadeloupe: "Guadeloupe",
      Martinique: "Martinique",
      Guyane: "Guyane",
      "La Réunion": "La Réunion",
      Mayotte: "Mayotte",
      "Polynésie française": "Polynésie française",
      "Nouvelle-Calédonie": "Nouvelle-Calédonie",
      "Îles Canaries": "Îles Canaries",
      "Ceuta & Melilla": "Ceuta & Melilla",
      Madère: "Madère",
      Açores: "Açores",
      Aruba: "Aruba",
      Curaçao: "Curaçao",
      "Saint-Martin": "Saint-Martin",
      Bermudes: "Bermudes",
      "Îles Caïmans": "Îles Caïmans",
      Gibraltar: "Gibraltar",
      france: "France",
      spain: "Espagne",
      italy: "Italie",
      usa: "États-Unis",
      uk: "Royaume-Uni",
      germany: "Allemagne",
      portugal: "Portugal",
      netherlands: "Pays-Bas",
      canada: "Canada",
      australia: "Australie",
      belgium: "Belgique",
      switzerland: "Suisse",
      greece: "Grèce",
      mexico: "Mexique",
      brazil: "Brésil",
      austria: "Autriche",
      croatia: "Croatie",
      thailand: "Thaïlande",
      morocco: "Maroc",
    },
  },
  calendar: {
    title: "Synchronisation automatique avec Airbnb",
    subtitle: "Connectez votre calendrier Airbnb en un clic",
    description:
      "Vos disponibilités se synchronisent automatiquement. Plus besoin de gérer deux calendriers séparément.",
    features: {
      sync: {
        title: "Synchronisation bidirectionnelle",
        description:
          "Vos calendriers Airbnb et DONKEY TRAVEL restent toujours à jour automatiquement",
      },
      realtime: {
        title: "Mises à jour en temps réel",
        description:
          "Chaque modification est instantanément synchronisée sur les deux plateformes",
      },
      smart: {
        title: "Gestion intelligente",
        description:
          "Évitez les doubles réservations grâce à notre système de synchronisation avancé",
      },
    },
    cta: "Connecter mon calendrier",
  },
  airbnb: {
    title: "Déjà propriétaire Airbnb ?",
    subtitle: "Rejoignez DONKEY TRAVEL et commencez à voyager gratuitement",
    description:
      "Importez automatiquement les informations de votre logement Airbnb et commencez à échanger dès aujourd'hui.",
    features: {
      verification: {
        title: "Vérification automatique de votre profil",
      },
      import: {
        title: "Import de vos photos et descriptions",
      },
      trust: {
        title: "Rejoignez une communauté de confiance",
      },
    },
    cta: "Connecter mon Airbnb",
  },
  membersMap: {
    title: "Carte des Membres",
    searchPlaceholder: "Rechercher une destination, ville...",
    filters: "Filtres",
    radius: "Rayon",
    radiusAuto: "Auto",
    reset: "Réinitialiser",
    filterPets: "Animaux acceptés",
    filterVerified: "Hôtes vérifiés",
    filterRating: "4.8+",
    filterAllTypes: "Tous les types",
    oneTraveler: "1 voyageur",
    multipleTravelers: "{{count}} voyageurs",
    dates: "Dates",
    addDates: "Ajouter des dates",
    startDate: "Départ",
    endDate: "Retour",
    listingsTitle: "Logements",
    listingsSubtitle: "Sélectionnez pour voir sur la carte.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Effacer les filtres",
    guestsShort: "p.",
    bedroomsShort: "ch.",
    surfaceAreaUnit: "m²",
    perNight: "/ nuit",
    online: "En ligne",
    offline: "Hors ligne",
    verified: "Vérifié",
    favorite: "Favori",
    favorites: "Favoris",
    members: "Membres",
    exchanges: "échanges",
    rooms: "pièces",
    mapTitle: "Carte interactive des membres DONKEY TRAVEL",
    countries: "Pays",
    results: "résultats",
    viewProfile: "Voir le profil",
    proposeExchange: "Proposer un échange",
    showFavoritesOnly: "Afficher uniquement les favoris",
    advancedSearch: "Recherche avancée",
    refineSearch: "Affiner votre recherche",
    activeFilter: "filtre actif",
    activeFilters: "filtres actifs",
    availabilityDates: "Dates de disponibilité",
    quickPeriods: "Périodes rapides",
    thisMonth: "Ce mois-ci",
    nextMonth: "Mois prochain",
    next3Months: "3 prochains mois",
    summer: "Été",
    autumn: "Automne",
    winter: "Hiver",
    arrival: "Arrivée",
    departure: "Départ",
    flexibleDates: "Dates flexibles",
    clear: "Effacer",
    propertyTypeTitle: "Type de logement",
    apartment: "Appartement",
    house: "Maison",
    villa: "Villa",
    loft: "Loft",
    capacityAndRooms: "Capacité & pièces",
    numberOfTravelers: "Nombre de voyageurs",
    all: "Tous",
    numberOfRooms: "Nombre de pièces",
    minimumSurface: "Surface minimum",
    equipments: "Équipements",
    wifi: "Wi‑Fi",
    pool: "Piscine",
    parking: "Parking",
    airConditioning: "Climatisation",
    garden: "Jardin",
    terrace: "Terrasse",
    fireplace: "Cheminée",
    barbecue: "Barbecue",
    bike: "Vélo",
    sauna: "Sauna",
    gym: "Salle de sport",
    washingMachine: "Lave‑linge",
    statusAvailability: "Statut & disponibilité",
    onlineAvailability: "Disponibilité en ligne",
    onlineOnly: "En ligne",
    verifiedMembersOnly: "Membres vérifiés uniquement",
    ratingExperience: "Note & expérience",
    minimumRating: "Note minimum",
    minimumExchanges: "Échanges minimum",
    matchingMembers: "membres correspondants",
    matchingMember: "membre correspondant",
    seeResults: "Voir les",
    result: "résultat",
    resetAllFilters: "Réinitialiser tous les filtres",
    rating: "Note",
    travelers: "Voyageurs",
    contact: "Contacter",
    searchMemberCity: "Rechercher un membre, ville, pays...",
    noFavorite: "Aucun favori",
    addFavoritesHint:
      "Ajoutez des membres à vos favoris en cliquant sur le cœur",
    noMemberFound: "Aucun membre trouvé",
    tryModifyFilters: "Essayez de modifier vos filtres",
    viewAllMembers: "Voir tous les membres",
    modifyFilters: "Modifier les filtres",
    favoritesOnly: "Favoris uniquement",
    addToFavorites: "Ajouter aux favoris",
    removeFromFavorites: "Retirer des favoris",
    loading: "Chargement...",
    sortBy: "Trier par",
    relevance: "Pertinence",
    newest: "Plus récents",
    noResults: "Aucun résultat trouvé",
    tryDifferentFilters: "Essayez d'ajuster vos filtres de recherche",
    membersList: "Liste des membres",
    membersFound: "membres trouvés",
    visibleMembers: "Membres visibles",
    legend: "Légende",
    availableProperty: "Logement disponible",
    selected: "Sélectionné",
    visibleByAll: "Visible par tous",
    allMembersSeeYou: "Tous les membres vous voient",
    targetedMode: "Mode ciblé",
    countriesSelected: "pays sélectionnés",
    countrySelected: "pays sélectionné",
    myVisibility: "Ma visibilité",
    whoCanSee: "Qui peut voir mon logement sur la carte ?",
    visibleByAllTitle: "Visible par tous",
    visibleByAllDesc:
      "Tous les membres de la communauté peuvent voir votre logement et vous proposer un échange.",
    visibleByAllHint: "Maximum de visibilité et d'opportunités",
    active: "ACTIF",
    targetedModeTitle: "Mode ciblé",
    targetedModeDesc:
      "Seuls les membres des pays que vous recherchez peuvent voir votre logement. Discrétion maximale.",
    targetedModeHint: "Vous ne voyez et n'êtes vu que par vos destinations",
    myDesiredDestinations: "Mes destinations souhaitées",
    clearAll: "Tout effacer",
    searchCountry: "Rechercher un pays...",
    member: "membre",
    membersCount: "membres",
    noCountryFound: "Aucun pays trouvé",
    targetedInfoTitle: "Votre logement n'apparaîtra que pour les membres en",
    targetedInfoDesc: "Les autres ne vous verront pas sur la carte.",
    targetedExample:
      "Exemple : si vous ne voulez aller qu'en Hollande, seuls les membres néerlandais verront votre profil.",
    selectAtLeastOneCountry:
      "Sélectionnez au moins un pays pour activer le mode ciblé.",
    propertyTypes: {
      appartement: "Appartement",
      maison: "Maison",
      villa: "Villa",
      loft: "Loft",
      luxe: "Luxe",
      insolite: "Insolite",
    },
    pricePerNight: "PRIX PAR NUIT (€)",
    min: "Min",
    max: "Max",
    sortResults: "TRI DES RÉSULTATS",
    sort: {
      recommended: "✨ Recommandés",
      priceAsc: "💶 Prix croissant",
      priceDesc: "💎 Prix décroissant",
    },
    amenitiesTitle: "ÉQUIPEMENTS",
    amenitiesTabs: {
      all: "TOUS",
      essentials: "ESSENTIELS",
      features: "CONFORT",
      location: "EMPLACEMENT",
      safety: "SÉCURITÉ",
    },
  },
  amenities: {
    wifi: "Wifi",
    tv: "Télévision",
    kitchen: "Cuisine",
    washing_machine: "Lave-linge",
    ac: "Climatisation",
    heating: "Chauffage",
    workspace: "Espace travail",
    iron: "Fer à repasser",
    hair_dryer: "Sèche-cheveux",
    pool: "Piscine",
    hottub: "Jacuzzi",
    patio: "Terrasse",
    bbq: "Barbecue",
    parking: "Parking gratuit",
    gym: "Salle de sport",
    fireplace: "Cheminée",
    breakfast: "Petit-déjeuner",
    beachfront: "Bord de mer",
    ski_in_out: "Pied des pistes",
    lake_access: "Accès lac",
    smoke_detector: "Détecteur de fumée",
    first_aid: "Kit premiers secours",
    fire_extinguisher: "Extincteur",
  },
  destinations: {
    title: "Destinations",
    searchPlaceholder: "Rechercher une destination...",
    destinationsFound: "destinations trouvées",
    noResults: "Aucun résultat",
    tryDifferentSearch: "Essayez une autre recherche",
    sortMembers: "Plus de membres",
    sortProperties: "Plus de logements",
    sortName: "Nom (A-Z)",
    all: "Tous",
    members: "membres",
    properties: "logements",
    explore: "Explorer cette destination",
    stats: {
      destinations: "Destinations",
      members: "Membres",
      properties: "Logements",
      countries: "Pays",
    },
    countriesIn: "Pays en",
    selectCountry: "— sélectionnez un pays pour filtrer",
    continents: {
      Europe: "Europe",
      "Amérique du Nord": "Amérique du Nord",
      "Amérique du Sud": "Amérique du Sud",
      Asie: "Asie",
      Afrique: "Afrique",
      Océanie: "Océanie",
    },
    countries: {
      Turquie: "Turquie",
      France: "France",
      "Pays-Bas": "Pays-Bas",
      "Royaume-Uni": "Royaume-Uni",
      Espagne: "Espagne",
      Italie: "Italie",
      Tchéquie: "Tchéquie",
      Grèce: "Grèce",
      Portugal: "Portugal",
      Autriche: "Autriche",
      Écosse: "Écosse",
      Hongrie: "Hongrie",
      Croatie: "Croatie",
      Danemark: "Danemark",
      Suède: "Suède",
      Suisse: "Suisse",
      Belgique: "Belgique",
      Norvège: "Norvège",
      Irlande: "Irlande",
      Pologne: "Pologne",
      Finlande: "Finlande",
      Islande: "Islande",
      Roumanie: "Roumanie",
      Monténégro: "Monténégro",
      "États-Unis": "États-Unis",
      Canada: "Canada",
      Mexique: "Mexique",
      "Costa Rica": "Costa Rica",
      Cuba: "Cuba",
      "Rép. Dominicaine": "Rép. Dominicaine",
      Guatemala: "Guatemala",
      Brésil: "Brésil",
      Argentine: "Argentine",
      Pérou: "Pérou",
      Colombie: "Colombie",
      Chili: "Chili",
      Équateur: "Équateur",
      Uruguay: "Uruguay",
      Bolivie: "Bolivie",
      Chine: "Chine",
      Thaïlande: "Thaïlande",
      Indonésie: "Indonésie",
      Vietnam: "Vietnam",
      "Corée du Sud": "Corée du Sud",
      Inde: "Inde",
      Cambodge: "Cambodge",
      Jordanie: "Jordanie",
      Maldives: "Maldives",
      "Sri Lanka": "Sri Lanka",
      Népal: "Népal",
      Philippines: "Philippines",
      Ouzbékistan: "Ouzbékistan",
      Égypte: "Égypte",
      Maroc: "Maroc",
      "Afrique du Sud": "Afrique du Sud",
      Tanzanie: "Tanzanie",
      Kenya: "Kenya",
      Sénégal: "Sénégal",
      Madagascar: "Madagascar",
      Tunisie: "Tunisie",
      Zimbabwe: "Zimbabwe",
      Namibie: "Namibie",
      "Île Maurice": "Île Maurice",
      Rwanda: "Rwanda",
      Australie: "Australie",
      "Nouvelle-Zélande": "Nouvelle-Zélande",
      "Polynésie française": "Polynésie française",
      Fidji: "Fidji",
      "Nouvelle-Calédonie": "Nouvelle-Calédonie",
      Samoa: "Samoa",
    },
    cities: {
      Paris: "Paris",
      "Mont Saint-Michel": "Mont Saint-Michel",
      Marseille: "Marseille",
      Amsterdam: "Amsterdam",
      Londres: "Londres",
      Barcelone: "Barcelone",
      Madrid: "Madrid",
      Venise: "Venise",
      Rome: "Rome",
      "Côte Amalfitaine": "Côte Amalfitaine",
      Prague: "Prague",
      Santorin: "Santorin",
      Athènes: "Athènes",
      Lisbonne: "Lisbonne",
      Porto: "Porto",
      Vienne: "Vienne",
      Édimbourg: "Édimbourg",
      Budapest: "Budapest",
      Dubrovnik: "Dubrovnik",
      Copenhague: "Copenhague",
      Stockholm: "Stockholm",
      Zermatt: "Zermatt",
      Bruges: "Bruges",
      Bergen: "Bergen",
      Dublin: "Dublin",
      Cracovie: "Cracovie",
      Helsinki: "Helsinki",
      Reykjavik: "Reykjavik",
      Bucarest: "Bucarest",
      Kotor: "Kotor",
      "New York": "New York",
      "San Francisco": "San Francisco",
      "Los Angeles": "Los Angeles",
      Miami: "Miami",
      Hawaï: "Hawaï",
      Vancouver: "Vancouver",
      Montréal: "Montréal",
      Toronto: "Toronto",
      Banff: "Banff",
      Québec: "Québec",
      Cancún: "Cancún",
      "Mexico City": "Mexico City",
      "San José": "San José",
      "La Havane": "La Havane",
      "Punta Cana": "Punta Cana",
      Antigua: "Antigua",
      "Buenos Aires": "Buenos Aires",
      "Rio de Janeiro": "Rio de Janeiro",
      "São Paulo": "São Paulo",
      "Machu Picchu": "Machu Picchu",
      Lima: "Lima",
      Carthagène: "Carthagène",
      Bogotá: "Bogotá",
      Santiago: "Santiago",
      Quito: "Quito",
      Montevideo: "Montevideo",
      "La Paz": "La Paz",
      Tokyo: "Tokyo",
      Kyoto: "Kyoto",
      Pékin: "Pékin",
      Shanghai: "Shanghai",
      "Hong Kong": "Hong Kong",
      Bangkok: "Bangkok",
      "Chiang Mai": "Chiang Mai",
      Bali: "Bali",
      "Hô Chi Minh-Ville": "Hô Chi Minh-Ville",
      Séoul: "Séoul",
      "Angkor Wat": "Angkor Wat",
      Colombo: "Colombo",
      Katmandou: "Katmandou",
      Manille: "Manille",
      Samarcande: "Samarcande",
      Petra: "Petra",
      "Le Caire": "Le Caire",
      Marrakech: "Marrakech",
      Chefchaouen: "Chefchaouen",
      "Le Cap": "Le Cap",
      Johannesburg: "Johannesburg",
      Zanzibar: "Zanzibar",
      "Safari Masai Mara": "Safari Masai Mara",
      Nairobi: "Nairobi",
      Dakar: "Dakar",
      Antananarivo: "Antananarivo",
      Tunis: "Tunis",
      "Chutes Victoria": "Chutes Victoria",
      Windhoek: "Windhoek",
      "Île Maurice": "Île Maurice",
      Kigali: "Kigali",
      Sydney: "Sydney",
      Melbourne: "Melbourne",
      "Grande Barrière de Corail": "Grande Barrière de Corail",
      Auckland: "Auckland",
      Queenstown: "Queenstown",
      "Bora Bora": "Bora Bora",
      Fidji: "Fidji",
      Nouméa: "Nouméa",
      Apia: "Apia",
      "Baie d'Halong": "Baie d'Halong",
      Maldives: "Maldives",
    },
  },
  story: {
    badge: "Une histoire vraie",
    title: "Chloé & Hugo : le troc parfait",
    subtitle:
      "Quand une Parisienne fatiguée de la ville rencontre un campagnard qui rêve de Paris...",
    chloé: {
      aptAlt: "Appartement de Chloé à Paris",
      quotaExceeded: "Quota Airbnb dépassé !",
      role: "Hôte Airbnb à Paris",
      speech1:
        "J'ai <strong class=\"text-red-600\">dépassé mon quota de 120 nuits</strong>... Impossible de louer. Et franchement, j'en ai marre du bruit parisien. 😩",
      nightsTag: "120/120 nuits",
      tiredTag: "Fatiguée de Paris",
      dreamsOf: "Chloé rêve de...",
      dreamTitle: "Le calme de la campagne",
      dreamDesc: "Du vert, du silence, un sauna... le paradis !",
      searching: "Cherche un gîte à la campagne",
      findsLuc: "Trouve Hugo !",
      speech2:
        "Enfin le calme ! Le sauna après une balade en forêt, c'est le <strong>bonheur absolu</strong>. 🌿✨",
      review:
        "Le gîte de Hugo est un petit paradis ! Le sauna après une balade en forêt, c'est le bonheur. On est devenus amis ! Je recommande à 200%.",
    },
    hugo: {
      giteAlt: "Gîte de Hugo à la campagne",
      available: "Disponible toute l'année",
      location: "Campagne, France",
      role: "Hôte Airbnb à la campagne",
      speech1:
        'Mon gîte a un <strong class="text-sage-600">jardin, un sauna et un fauteuil massage</strong>... mais j\'en peux plus de la campagne. Je rêve de Paris ! 🗼',
      dreamsOf: "Hugo rêve de...",
      dreamTitle: "Les lumières de Paris",
      dreamDesc: "Les musées, les cafés, la Tour Eiffel... enfin !",
      searching: "Cherche un appart à Paris",
      findsMaya: "Trouve Chloé !",
      speech2:
        "Paris, enfin ! Le Louvre, les bistrots, les toits... c'est <strong>magique</strong> ! 🗼🥐",
      review:
        "L'appart de Chloé est incroyable, vue sur les toits de Paris ! Et tout ça sans toucher à son quota. Le troc, c'est génial !",
    },
    tags: {
      garden: "Jardin",
      sauna: "Sauna",
      massage: "Massage",
      countryside: "Campagne",
      bigGarden: "Grand jardin",
      restaurants: "Restos",
      museums: "Musées",
    },
    match: {
      spark: "Le déclic !",
      title: "Ils découvrent DONKEY TRAVEL",
      perfect: "Match parfait !",
    },
    quota: {
      title: "Hors quota Airbnb = 100% gratuit !",
      description:
        "Le séjour de Hugo ne touche pas au quota de Chloé. C'est un échange, pas une location. Tout le monde y gagne !",
      totalCost: "Coût total",
      quotaNight: "Nuit quota",
    },
    happyEnd: {
      title: "Tout le monde est heureux ! 🎊",
      subtitle:
        "Chloé et Hugo sont devenus amis. Ils partagent leurs astuces d'hôtes et prévoient déjà un prochain échange !",
      exchangeSuccess: "Échange réussi",
      newFriendship: "Nouvelle amitié",
      outsideQuota: "Hors quota",
      free: "100% gratuit",
    },
  },
  messaging: {
    messages: "Messages",
    searchPlaceholder: "Rechercher une conversation...",
    all: "Tous",
    unread: "Non lus",
    archived: "Archivés",
    online: "En ligne",
    offline: "Hors ligne",
    messagePlaceholder: "Écrire un message...",
    writeMessage: "Écrire un message",
    sending: "Envoi en cours...",
    characters: "caractères",
    noConversation: "Aucune conversation",
    notificationMessage: "Nouveau message",
    quickActions: "Actions rapides",
    proposeExchange: "Proposer un échange",
    proposeExchangeTitle: "Proposition d'échange",
    checkAvailability: "Vérifier les disponibilités",
    report: "Signaler",
    hisProperty: "Son logement",
    rooms: "chambres",
    guests: "voyageurs",
    verifiedOwner: "Propriétaire vérifié",
    viewAirbnbListing: "Voir l'annonce Airbnb",
    details: "Détails",
    desiredDates: "Dates souhaitées",
    arrival: "Arrivée",
    departure: "Départ",
    period: "Période",
    duration: "Durée",
    nights: "nuits",
    numberOfTravelers: "Nombre de voyageurs",
    traveler: "voyageur",
    travelers: "voyageurs",
    person: "personne",
    persons: "personnes",
    dateFlexibility: "Flexibilité des dates",
    exactDates: "Dates exactes",
    flex1to2: "± 1-2 jours",
    flex3to5: "± 3-5 jours",
    flexWeek: "± 1 semaine",
    personalMessage: "Message personnel",
    summary: "Résumé",
    termsAccept: "J'accepte les conditions d'échange de DONKEY TRAVEL",
    sendProposal: "Envoyer la proposition",
    proposalSent: "Proposition envoyée !",
    proposalSentMessage: "Votre proposition a été envoyée avec succès",
    close: "Fermer",
    today: "Aujourd'hui",
    selectConversation: "Sélectionnez une conversation",
    selectConversationHint:
      "Choisissez un propriétaire pour commencer à discuter",
  },
  destination_introuvable: `Destination introuvable`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `Cette destination n&apos;existe pas ou a été déplacée.`,
  retour_aux_destinations: `Retour aux destinations`,
  pr_t___d_couvrir_: `Prêt à découvrir `,
  r_server_ce_s_jour: `Réserver ce séjour`,
  explorer_d_apos_autres_destinations: `Explorer d&apos;autres destinations`,
  acc_s_r_serv_: `Accès réservé`,
  europe_unique: `Europe unique`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `50EUR/an pour échanger dans toute l’Europe.`,
  lancement_2026: `Lancement 2026`,
  club_d__change_h_tes_airbnb: `Club d'échange hôtes Airbnb`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Optimisez vos périodes creuses grâce aux échanges`,
  rejoindre_le_club: `Rejoindre le club`,
  trouver_un_h_te: `Trouver un hôte`,
  r_serv__aux_h_tes_traveltrok: `Réservé aux hôtes DONKEY TRAVEL`,
  voyagez_gratuitement_gr_ce___votre_logement: `Voyagez gratuitement grâce à votre logement`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Accueillez des membres et faites-vous accueillir en retour. Un échange simple, direct et sans argent entre propriétaires.`,
  devenir_h_te: `Devenir hôte`,
  comment__a_marche__: `Comment ça marche ?`,
  amis_partageant_un_repas_en_corse: `Amis partageant un repas en Corse`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `"Nous avons échangé notre maison à Lyon contre une villa en Corse. Coût : 0€."`,
  sophie___marc__membres_depuis_2023: `Sophie & Marc, membres depuis 2023`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `Pas de monnaie, pas de points. Juste un accord entre deux propriétaires. Je viens chez toi, tu viens chez moi.`,
  "1__accord_mutuel": `1. Accord mutuel`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `Vous trouvez un membre qui vous plaît et vous vous mettez d'accord pour échanger vos logements.`,
  "2__flexibilit__totale": `2. Flexibilité totale`,
  "3__z_ro_comptabilit_": `3. Zéro comptabilité`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `Pas de points à compter. Juste le plaisir de partager et de se rencontrer.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `Pourquoi les hôtes adorent ce système ?`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `Plus qu'une économie, c'est une nouvelle façon de voyager.`,
  "0__de_frais": `0€ de frais`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `Les échanges sont totalement gratuits. Pas de frais de service, pas de frais de ménage (sauf accord spécifique).`,
  confiance_totale: `Confiance totale`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Seuls les hôtes vérifiés peuvent échanger. Vous accueillez quelqu'un qui connaît la valeur d'un logement.`,
  simplicit_: `Simplicité`,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Oubliez la valeur des points. Une nuit est une nuit. L'échange est basé sur la confiance entre hôtes.`,
  rejoignez_la_communaut__des_h_tes: `Rejoignez la communauté des hôtes`,
  rejoignez_la_communaut__et_commencez____changer_: `Rejoignez la communauté et commencez à échanger.`,
  commencer_maintenant: `Commencer maintenant`,
  pr_nom_invalide: `Prénom invalide`,
  nom_invalide: `Nom invalide`,
  email_invalide: `Email invalide`,
  s_lectionne_un_pays: `Sélectionne un pays`,
  s_lectionne_un_mode_tarifaire: `Sélectionne un mode tarifaire`,
  s_lectionne_ton_usage: `Sélectionne ton usage`,
  tu_dois_accepter_les_conditions: `Tu dois accepter les conditions`,
  france: `France`,
  belgique: `Belgique`,
  suisse: `Suisse`,
  canada: `Canada`,
  allemagne: `Allemagne`,
  espagne: `Espagne`,
  italie: `Italie`,
  portugal: `Portugal`,
  royaume_uni: `Royaume-Uni`,
  _tats_unis: `États-Unis`,
  autre: `Autre`,
  merci_de_corriger_les_champs_en_erreur_: `Merci de corriger les champs en erreur.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `Une erreur est survenue. Réessaie dans quelques instants.`,
  compte_cr___avec_succ_s: `Compte créé avec succès`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `Tu recevras un email pour finaliser ton profil voyageur/hôte.`,
  cr_er_un_autre_compte: `Créer un autre compte`,
  activation_traveltrok: `Activation DONKEY TRAVEL`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Choisis ton mode: voyageur, hôte, ou usage mixte.`,
  pr_nom: `Prénom`,
  jeanne: `Jeanne`,
  nom: `Nom`,
  durand: `Durand`,
  email: `Email`,
  jeanne_email_com: `jeanne@email.com`,
  t_l_phone__optionnel_: `Téléphone (optionnel)`,
  pays: `Pays`,
  choisir_un_pays: `Choisir un pays`,
  mode_tarifaire: `Mode tarifaire`,
  voyageur: `Voyageur`,
  nuit: `nuit`,
  h_te: `Hôte`,
  pro_multi_logements: `Pro multi-logements`,
  mois: `mois`,
  usage_principal: `Usage principal`,
  je_voyage_principalement: `Je voyage principalement`,
  je_loue_principalement: `Je loue principalement`,
  je_fais_les_deux: `Je fais les deux`,
  nombre_de_logements: `Nombre de logements`,
  logement: `logement`,
  logements: `logements`,
  a: `a`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `J’accepte les conditions d’utilisation et la politique de confidentialité.`,
  cr_ation_en_cours___: `Création en cours...`,
  cr_er_mon_compte_traveltrok: `Créer mon compte DONKEY TRAVEL`,
  r_servation_de_logements: `Réservation de logements`,
  support_h_te_prioritaire: `Support hôte prioritaire`,
  carte___filtres_avanc_s: `Carte + filtres avancés`,
  flux_de_r_servation__tape_par__tape: `Flux de réservation étape par étape`,
  couverture_dommages_assistance: `Couverture dommages/assistance`,
  multi_logements___reporting: `Multi-logements + reporting`,
  accueil: `Accueil`,
  tarifs: `Tarifs`,
  "0__commission_pour_les_h_tes": `0% Commission pour les hôtes`,
  r_volution_traveltrok: `Révolution DONKEY TRAVEL`,
  gardez_100__de_ce_que_vous_gagnez: `Gardez 100% de ce que vous gagnez`,
  simple: `Simple`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `Tu connais ton coût avant de réserver. Aucun effet surprise au paiement.`,
  honn_te: `Honnête`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `Le même principe pour tous: voyageur et hôte sont traités avec la même règle.`,
  utile: `Utile`,
  je_suis_voyageur: `Je suis voyageur`,
  je_suis_h_te: `Je suis hôte`,
  j_ai_plusieurs_logements: `J'ai plusieurs logements`,
  simulateur_comparatif_host: `Simulateur comparatif host`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Compare Booking, Airbnb et DONKEY TRAVEL avec tes propres chiffres.`,
  nombre_de_nuits: `Nombre de nuits`,
  property_price___night__eur_: `Property price / night (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Autres frais (ménage, accueil, linge...) EUR`,
  option___qui_paie_les_frais__5____: `Option : Qui paie les frais (5%) ?`,
  standard__recommand__: `Standard (Recommandé)`,
  pro___attractivit_: `Pro / Attractivité`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `Le voyageur paie 5% en plus. Vous touchez 100% du prix.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `Vous payez les 5%. Le prix affiché au voyageur est net.`,
  base_de_calcul: `Base de calcul`,
  nuit_s_: `nuit(s)`,
  autres_frais: `Autres frais`,
  montant_total_avant_commissions: `Montant total avant commissions`,
  plateforme: `Plateforme`,
  frais_h_te: `Frais hôte`,
  frais_voyageur: `Frais voyageur`,
  total_voyageur: `Total voyageur`,
  net_h_te: `Net hôte`,
  avantage_fiscal___pro: `Avantage Fiscal & Pro`,
  consultez_votre_expert_comptable_: `Consultez votre expert-comptable.`,
  diff_rence_h_te__claire_et_vendeuse: `Différence hôte: claire et vendeuse`,
  frais_h_te___an: `Frais hôte / an`,
  _conomie_compar_e___booking: `Économie comparée à Booking`,
  _conomie_vs_airbnb: `Économie vs Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Exemple typique sur 1 an (hôte)`,
  nuits_r_serv_es: `Nuits réservées`,
  s_jours___an: `Séjours / an`,
  chiffre_d_affaires_annuel: `Chiffre d'affaires annuel`,
  frais_traveltrok: `Frais DONKEY TRAVEL`,
  frais_booking__15__: `Frais Booking (15%)`,
  frais_airbnb__15_5__: `Frais Airbnb (15,5%)`,
  net_h_te_traveltrok: `Net hôte DONKEY TRAVEL`,
  comparatif_des_modes: `Comparatif des modes`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `Ce que tu actives selon ton usage TRAVELTROK.`,
  fonction: `Fonction`,
  pro: `Pro`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Créer ton compte et ton mode d’usage`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Choisis si tu démarres en voyageur, hôte, ou les deux. Tu pourras changer à tout moment.`,
  location_simple_c_t__voyageur: `Location simple côté voyageur`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Recherche, filtres, réservation rapide et coût transparent.`,
  gestion_h_te_simplifi_e: `Gestion hôte simplifiée`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Publie ton logement, gère ton calendrier et réponds rapidement aux demandes.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Couverture incluse pour le voyageur et pour l’hôte.`,
  support_op_rationnel: `Support opérationnel`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Accompagnement en cas de litige, annulation ou besoin de médiation.`,
  faq_tarifs: `FAQ tarifs`,
  vraiment_0__de_commission_pour_l_h_te__: `Vraiment 0% de commission pour l’hôte ?`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `Oui. L’hôte reçoit 100% du prix qu’il fixe. Aucun frais de service, aucun frais de traitement.`,
  combien_paie_le_voyageur__: `Combien paie le voyageur ?`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `Le voyageur paie une commission de 5% sur le montant de la location. Cela couvre les frais de fonctionnement, l’assurance et le support.`,
  puis_je__changer_mon_logement_gratuitement__: `Puis-je échanger mon logement gratuitement ?`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `Oui ! Si vous êtes hôte, vous pouvez échanger votre logement avec d'autres membres sans aucun frais (0€).`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `Pourquoi ce modèle est-il moins cher ?`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `En ne prenant que 5% au total (contre 15% à 20% ailleurs), nous rendons le voyage plus accessible tout en rémunérant mieux les hôtes.`,
  pr_t___activer_ton_mode_traveltrok__: `Prêt à activer ton mode DONKEY TRAVEL ?`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Voyageur, hôte, ou hybride: commence avec une logique claire et des coûts maîtrisés.`,
  cr_er_mon_compte: `Créer mon compte`,
  explorer_les_logements: `Explorer les logements`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `Réduction de 50% en 2026: 25EUR/an au lieu de 50EUR/an. Prix garanti à vie pour les 1000 premiers inscrits.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Basse saison, pause, rencontres entre hôtes, économies vacances: tout est pensé pour les hôtes actifs en Europe.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Voyagez moins cher (5% de frais), hébergez sans frais (0%). Le modèle le plus équitable du marché.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `Fini les commissions de 15% ou plus. Avec DONKEY TRAVEL, les hôtes ne paient aucuns frais. Les voyageurs paient seulement 5% de frais de service. C'est ça, l'équité.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Hypothèse comparatif: Booking commission hôte 15% (selon pays et programme), Airbnb mode host-only à 15,5% côté hôte et 0 côté voyageur.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `Les frais de 5% peuvent être déductibles de vos charges si vous êtes une société. Le modèle 0% simplifie la comptabilité des particuliers.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `Avec DONKEY TRAVEL, vous pouvez baisser le prix de vos locations pour louer plus souvent. Vos frais hôte restent fixes, donc votre net reste solide.`,
  en_moyenne__c_est_environ___annualhostcase_average: `En moyenne, c'est environ {{savings}}EUR d'économie annuelle face aux plateformes à commission.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Hypothèses: 100EUR la nuit, 30EUR de ménage, durée moyenne 3 nuits, 50% de taux de réservation annuel.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `DONKEY TRAVEL collecte uniquement les données nécessaires au fonctionnement du service: compte, profil, échanges et support.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `Vos données ne sont partagées qu'avec les services techniques indispensables (authentification, hébergement, sécurité) et ne sont jamais revendues.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `Vous pouvez demander la mise à jour ou la suppression de vos données personnelles depuis votre compte ou en contactant le support.`,
  votre_demande: `Votre demande`,
  recapitulatif_de_vos_envies_de_voyage_et_compagnons_pour_vos_futurs_echanges: `Récapitulatif de vos envies de voyage et compagnons pour vos futurs échanges.`,
  "help.faq.q1.question": "Combien coûte l'abonnement ?",
  "help.faq.q1.answer":
    "50€/an pour la formule classique. Il y a une réduction de lancement à 25€/an pour 2026.",
  "help.faq.q2.question":
    "Est-ce que je peux échanger sans avoir les mêmes dates ?",
  "help.faq.q2.answer":
    "Absolument. Notre système d'échange flexible permet à l'hôte 1 de venir chez l'hôte 2 en Juillet, et à l'hôte 2 de venir chez l'hôte 1 en Septembre, de façon asynchrone.",
  "help.faq.q3.question":
    "Le site est-il vraiment réservé aux hôtes notés 4,5 et plus ?",
  "help.faq.q3.answer":
    "Oui. Donkey Travel est un club fermé. Lors de l'inscription, nous vérifions le lien de votre annonce Airbnb pour nous assurer que votre note moyenne est d'au moins 4,5/5 et que vous avez des commentaires.",
  "help.faq.q4.question": "Comment s'organisent les échanges ?",
  "help.faq.q4.answer":
    "Il n'y a pas de système de points. Les membres décident eux-mêmes combien de nuits ils souhaitent échanger sur la base du prix qu'ils indiquent. L'annonce Airbnb sert de référence pour vérifier si la proposition est équitable et crédible.",
  "help.faq.q5.question":
    "Y a-t-il des frais supplémentaires (ménage, service) ?",
  "help.faq.q5.answer":
    "Non ! Le principe de Donkey Travel est l'échange 100% gratuit entre hôtes. C'est l'hôte qui accueille qui prépare le logement, et c'est l'invité qui le rend dans un état de propreté irréprochable (ou gère le ménage avec l'hôte selon leurs accords).",
  "help.faq.q6.question": "Puis-je lier plusieurs annonces Airbnb ?",
  "help.faq.q6.answer":
    "Oui, cela est prévu dans nos prochaines mises à jour pour vous permettre de synchroniser plusieurs hébergements et gagner encore plus d'opportunités d'échange.",
  "help.faq.q7.question": "Que se passe-t-il si un échange est annulé ?",
  "help.faq.q7.answer":
    "En cas d'annulation, nous vous invitons à communiquer avec votre hôte via notre messagerie interne pour trouver un nouvel accord ou de nouvelles dates.",
  "help.faq.q8.question":
    "Comment la confiance et la sécurité sont-elles garanties ?",
  "help.faq.q8.answer":
    "En n'acceptant que des hôtes confirmés (note > 4,5), nous nous assurons que tous les membres savent ce que signifie 'recevoir'. De plus, l'identité et les annonces sont vérifiées par notre équipe.",
};
